<template>
  <div class="vx-row">
      <div class="vx-col md:w-4/4 w-full mb-base">
            <vx-card>

            <!-- Filter Date -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Date Activity </span>
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                    <flat-pickr id="dtp-transaction-start-date" :config="configFromdateTimePicker" v-model="fromDate" placeholder="From Date" @on-change="onFromChange" />
                    <div style="font-size: 12px">
                    * Maximum 31 days
                    </div>
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                    <flat-pickr id="dtp-transaction-end-date" :config="configTodateTimePicker" v-model="toDate" placeholder="To Date" @on-change="onToChange" />
                </div>
            </div>

            <!-- Filter User -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>User</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    <v-select 
                        autocomplete
                        v-model="selected_user"
                        placeholder="Select user"
                        :options="user_list"
                    >
                    </v-select>
                    <div class="w-full self-center" style="font-size: 12px">
                        Leave this option empty to select all user <br>
                    </div>
                </div>
            </div>

            <!-- Filter Menu -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Menu</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    <v-select
                        id="cbo-menu" 
                        inputId="txt-menu"
                        autocomplete
                        v-model="selected_menu"
                        placeholder="Select menu"
                        :options="menu_list"
                    >
                    </v-select>
                </div>
            </div>

             <!-- Filter Id Session -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Id Session</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                     <vs-input
                        v-model="session_search"
                        id="txt-search"
                        type="text"
                        placeholder="Search by ID session"
                        class="w-full"
                        name="identity number"
                    />
                </div>
            </div>


             <!-- Button -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>&nbsp;</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-button id="btn-filter" icon-pack="feather" icon="icon-search" v-on:click="fetchData(1,20,true)" class="mr-3 mb-2 float-left">Filter</vs-button>
                    <vs-button id="btn-reset" icon-pack="feather" icon="icon-refresh-cw" color="warning" v-on:click="resetFilter()" class="mr-3 mb-2 float-left">Reset</vs-button>
                </div>
            </div>
        </vx-card>
      </div>

      <vx-card>
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                    <span
                    class="mr-2"
                    >{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage * limit > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu id="ddl-page-limit">
                    <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 20)">
                    <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                    <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item id="ddl-page-limit-3" @click="fetchData(1, 100)">
                    <span>100</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item id="ddl-page-limit-4" @click="fetchData(1, 150)">
                    <span>150</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item id="ddl-page-limit-5" @click="fetchData(1, totalData)">
                    <span>Show All</span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
            </div>   

            <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
            <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                <vs-button id="btn-export-csv" class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
            </div>
        </div>   

        <ag-grid-vue
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="dataAudit"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="limit"
          :suppressPaginationPanel="true"
          :enableCellTextSelection="true"
        ></ag-grid-vue>
        <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage" />
    </vx-card>

  </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert2';
import vSelect from 'vue-select';
import 'flatpickr/dist/flatpickr.css';
import { url } from "@/configs/apiUrl";
import { AgGridVue } from "ag-grid-vue";
import 'vue-simple-suggest/dist/styles.css';
import AxiosCall from "@/global/AxiosCall";
import flatPickr from 'vue-flatpickr-component';
import VueSimpleSuggest from 'vue-simple-suggest';
import ColumnClickedAgGridComponent from "@/components/audit-trail/ColumnClickedAgGridComponent";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";

export default {
    name: "AuditTrail",
    components: {
        AgGridVue,
        flatPickr,
        'v-select': vSelect,
        VueSimpleSuggest,
    },
    data() {
        return {
            fromDate: null,
            toDate: null,
            configFromdateTimePicker: {
                minDate: null,
                maxDate: null,
                dateFormat: 'd-m-Y',
            },
            configTodateTimePicker: {
                minDate: null,
                dateFormat: 'd-m-Y',
            },
            menu_list: [
                {
                    label : 'Login'
                },
                {
                    label : 'Logout'
                },
                {
                    label : 'Register'
                },
                {
                    label : 'Services'
                },
                {
                    label : 'Tourism & Transport'
                },
                {
                    label : 'Payment'
                },
                {
                    label : 'Retail'
                },
                {
                    label : 'Merchant Management'
                },
                {
                    label : 'Merchant Verification'
                },
                {
                    label : 'Shiftdate Mapping'
                },
                {
                    label : 'Device Type'
                },
                {
                    label : 'Device Registration'
                },
                {
                    label : 'Device Assigment'
                },
                {
                    label : 'Device Report'
                },
                {
                    label : 'Device Monitoring'
                },
                {
                    label : 'Device Activity Log'
                },
                {
                    label : 'Transaction Summary'
                },
                {
                    label : 'Device Event'
                },
                {
                    label : 'Device Update'
                },
                {
                    label : 'User Management'
                },
                {
                    label : 'Audit Trail'
                },
                {
                    label : 'Settlement Configuration'
                }
            ],
            user_list : [],
            dataAudit : [],
            selected_user : null,
            selected_menu: null,
            model: null,
            session_search : null,
            loading: false,
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
                filterParams: {
                    applyButton: true,
                    newRowsAction: 'keep'
                },
            },
            columnDefs: [
                {
                    headerName: "ID Session",
                    field: "session_id",
                    width:200,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Datetime",
                    field: "date_time",
                    width:200,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "User",
                    field: "user_name",
                    width:200,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Menu",
                    field: "menu",
                    width:200,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Activity",
                    field: "activity",
                    width:200,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Data Before",
                    field: "data_before",
                    width:200,
                    filter: true,
                    editable: false,
                    cellRendererFramework: ColumnClickedAgGridComponent,
                },
                {
                    headerName: "Data After",
                    field: "data_after",
                    width:200,
                    filter: true,
                    editable: false,
                    cellRendererFramework: ColumnClickedAgGridComponent,
                },
            ],
            dataCount:0,
            totalPage: 0,
            page : 1,
            limit : 20,
            totalData: 1,
            isFilter : false,
        };
    },
    watch: {
        "$store.state.windowWidth"(val) {
        if (val <= 576) {
            this.maxPageNumbers = 4;
            this.gridOptions.columnApi.setColumnPinned("Channel", null);
        } else this.gridOptions.columnApi.setColumnPinned("Channel", "left");
        
        },
    },
    computed: {
        currentPage: {
            get(){
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val){
                this.fetchData(val, this.limit);
            }
        }
    },
    methods: {
        openLoading(){
            this.$vs.loading({
                type: "default"
            });
        },

        fetchData(page,limit,filter){
            this.page = page
            this.limit = limit
            let newPage = page;
            if(this.dataCount != 0){
                let totalPages = Math.ceil(this.dataCount / limit);
                if(page > totalPages) {
                    newPage = this.totalPages
                }
            }
            newPage;

            let newUrl = url.audit_trail.log_activity_user+ "?page=" + page + "&limit=" + limit

            if(!filter && !this.isFilter){
                this.openLoading();
                AxiosCall.Get(newUrl).then(res => {
                    this.$vs.loading.close();
                    this.dataAudit = [];
                    this.dataCount = 0
                    this.totalPage = 0
                    if(res.data.length !== 0) {
                        this.totalData = parseInt(res.data.total)
                        let no = ((page - 1) * limit) + 1;
                        for(let data of res.data.data){
                            data.no = no;
                            data.data_before = JSON.stringify(data.data_before)
                            data.data_after = JSON.stringify(data.data_after)
                            
                            //data.date_time = moment(data.date_time).format("YYYY-MM-DD LTS")
                            this.dataAudit.push(data);
                            no++;
                        }

                        this.dataCount = res.data.total;
                        this.page = page;
                        if(limit >= this.dataCount){
                            this.limit = this.dataAudit.length
                        }else{
                            this.limit = limit;
                        }
                        this.gridApi.paginationSetPageSize(this.limit);
                        this.totalPage = res.data.lastPage;
                    }else{
                        this.totalData = parseInt(res.data.total)
                    }
                }).catch(e => {
                    console.log(e)
                    this.$vs.loading.close();
                    this.dataAudit = [];
                    this.dataCount = 0
                    this.totalPage = 0
                })
            }else{
                let fromDate = ''
                let toDate = ''

                if ((this.fromDate=='') && (this.toDate!='')) {
                    this.$vs.loading.close();
                    swal.fire({
                        type: 'warning',
                        title: 'Alert',
                        text: 'Start date must be filled!',
                    })
                    return false
                }

                if ((this.fromDate==null) && (this.toDate!=null)) {
                    this.$vs.loading.close();
                    swal.fire({
                        type: 'warning',
                        title: 'Alert',
                        text: 'Start date must be filled!',
                    })
                    return false
                }

                if ((this.fromDate!=null) && (this.toDate==null)) {
                    this.$vs.loading.close();
                    swal.fire({
                        type: 'warning',
                        title: 'Alert',
                        text: 'End date must be filled!',
                    })
                    return false
                }

                if ((this.fromDate!='') && (this.toDate=='')) {
                    this.$vs.loading.close();
                    swal.fire({
                        type: 'warning',
                        title: 'Alert',
                        text: 'End date must be filled!',
                    })
                    return false
                }

                this.isFilter = true

                fromDate = this.fromDate.split("-").reverse().join("-")
                toDate = this.toDate.split("-").reverse().join("-")

                let start_date = moment(fromDate)
                let end_date = moment(toDate)
                let range_date = end_date.diff(start_date, "days")
                if (range_date > 31) {
                    this.$vs.loading.close();
                    swal.fire({
                        type: 'warning',
                        title: 'Alert',
                        text: 'Maximum date range is 31 days!',
                    })
                    return false
                }else{
                    newUrl +=  "&start_date="+ fromDate + "&end_date=" + toDate
                }

                if(this.selected_menu !== null) {
                    newUrl += "&menu=" + this.selected_menu.label
                }

                if(this.selected_user !== null){
                     newUrl += "&user_id=" + this.selected_user.id
                }

                if(this.session_search !== null){
                    newUrl += "&session_id=" + this.session_search
                }

                AxiosCall.Get(newUrl).then(res => {
                    this.$vs.loading.close();
                    this.dataAudit = [];
                    this.dataCount = 0
                    this.totalPage = 0
                    if(res.data.length !== 0) {
                        this.totalData = parseInt(res.data.total)
                        let no = 1
                        for(let data of res.data.data){
                            data.no = ((this.page -1) * this.limit) + no;
                            //data.date_time = moment(data.date_time).locale('id').format("YYYY-MM-DD LTS")
                            this.dataAudit.push(data);
                            no++;
                        }

                        this.dataCount = res.data.total;
                        this.page = page;
                        if(limit >= this.dataCount){
                            this.limit = this.dataAudit.length
                        }else{
                            this.limit = limit;
                        }
                        this.gridApi.paginationSetPageSize(this.limit);
                        this.totalPage = res.data.lastPage;
                        
                    }else{
                        this.totalData = parseInt(res.data.total)
                    }
                }).catch(e => {
                    console.log(e)
                    this.$vs.loading.close();
                    this.dataAudit = [];
                    this.dataCount = 0
                    this.totalPage = 0
                })
            }
        },

        onFromChange(selectedDates, dateStr) {
            this.$set(this.configTodateTimePicker, 'minDate', dateStr);
        },
        
        onToChange(selectedDates, dateStr) {
            this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
        },

        resetFilter() {
            this.selected_user = null
            this.selected_menu = null
            this.fromDate = null
            this.toDate = null
            this.session_search = null
            this.page = 1
            this.limit = 20
            this.isFilter = false
            this.fetchData(1, 20)
        },
    },
    created(){
        AxiosCall.Get(url.svd.user.list + "?role_group=all" ).then(resp => {
            this.user_list = []
            if (typeof resp.data.data !== 'undefined'){
                for(let data of resp.data.data) {
                    data.label = data.username
                    this.user_list.push(data)
                }
        }
        }).catch(e => {
            console.log(e)
        })
    },
    mounted(){

        this.gridApi = this.gridOptions.api;
        this.gridOptions.getRowStyle = function(params) {
          if (params.node.rowIndex % 2 === 0) {
            return { background: '#f9f9f9' }
          }
        }
        
        this.gridOptions.rowHeight = 42;
        this.fromDate = moment().subtract(31, 'days').format("DD-MM-YYYY")
        this.toDate = moment().format("DD-MM-YYYY")

        this.fetchData(1, 20)
    }
}
</script>

<style>
  .vdp-datepicker input {
      padding: .7rem;
      font-size: 1rem;
      border-radius: 5px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      color: #626262;
      width: 100%
  }

  .flatpickr-input {
      padding: .7rem;
      font-size: 1rem;
      border-radius: 5px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      color: #626262;
      width: 100%;
  }

  .vue-simple-suggest.designed .suggestions {
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      top: calc(100% + 5px);
      border-radius: 3px;
      border: 1px solid #aaa;
      background-color: #fff;
      opacity: 1;
      z-index: 1000;
      overflow: scroll;
      height: 300px;
  }
  .cell-wrap-text {
      white-space: pre-wrap !important;
  }
</style>